import { cardDefaults, linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { CardMethod, LinkMethod } from "@/modules/billing/paymentMethods.ts";
import type { OmiseConfig, OmiseCreditCardConfig } from "@warrenio/api-spec/spec.oats.gen";
import React from "react";

/* eslint-disable react-refresh/only-export-components */

const OmisePaymentForm = React.lazy(() => import("@/modules/billing/omise/OmisePaymentForm.tsx"));
const OmiseCardAddForm = React.lazy(() => import("@/modules/billing/omise/OmiseCardAddForm.tsx"));
const OmiseCardPaymentForm = React.lazy(() => import("@/modules/billing/omise/OmiseCardPaymentForm.tsx"));

export function makeOmiseLink(config: OmiseConfig) {
    return config.methods.map(
        (method): LinkMethod => ({
            ...linkDefaults(config, method),
            PaymentForm: (props) => <OmisePaymentForm {...props} method={method} config={config} />,
        }),
    );
}

export function makeOmiseCard(config: OmiseCreditCardConfig): CardMethod {
    return {
        ...cardDefaults(config),
        PaymentForm: (props) => <OmiseCardPaymentForm {...props} config={config} />,
        AddForm: (props) => <OmiseCardAddForm {...props} config={config} />,
    };
}
